const WEBSITE_ORIGIN = "https://antaia.io";

// Every Prismic document type the Help section renders in-app (see
// api/prismic.js HELP_SEARCHABLE_TYPES / hooks/query/help.js) — a link to any of
// these stays inside the platform instead of bouncing out to the marketing website.
const HELP_DOCUMENT_TYPES = ["help_article", "help_guide", "help_hub"];

/**
 * Resolves a Prismic link field found inside `help_article` slice content.
 *
 * Links within help_article content only ever point to other Help-section
 * documents (help_article/help_guide/help_hub) — those resolve to in-app
 * navigation, kind "internal". Any other Document type (cluster, solution, etc.)
 * is legacy/out-of-scope content and falls back to an external link so it doesn't
 * break, but is not something the platform fetches or renders.
 *
 * Returns null | { kind: "internal", uid } | { kind: "external", url }
 */
export function resolvePrismicLink(linkField) {
  if (!linkField || linkField.link_type === "Any") return null;
  if (linkField.link_type === "Web") return { kind: "external", url: linkField.url };
  if (linkField.link_type === "Document" && linkField.uid) {
    if (HELP_DOCUMENT_TYPES.includes(linkField.type)) {
      return { kind: "internal", uid: linkField.uid };
    }
    return { kind: "external", url: `${WEBSITE_ORIGIN}/${linkField.uid}` };
  }
  return null;
}
